import {
  AccountOwner,
  OwnerType,
  TaxIdType,
  TaxIdTypeDisplay,
} from '../../types'
import { find } from 'lodash'

export const formatTaxId = (taxIdType?: TaxIdType, taxId?: string) =>
  `${taxIdType ? TaxIdTypeDisplay[taxIdType] : 'Unknown'}: ${taxId || ''}`

export const findAndFormatJointOwnerTaxIds = (accountOwners: AccountOwner[]) =>
  accountOwners
    .filter(accountOwner => accountOwner.ownerType === OwnerType.JointOwner)
    .map(({ taxIdType, taxId }) => formatTaxId(taxIdType, taxId))

export const findTaxIdTypeAndFormatTaxId = (
  accountOwners: AccountOwner[],
  taxId?: string
) =>
  formatTaxId(
    taxId ? find(accountOwners, { taxId })?.taxIdType : undefined,
    taxId
  )
